import { render, staticRenderFns } from "./productimageSlider.vue?vue&type=template&id=e6aee3cc&"
import script from "./productimageSlider.vue?vue&type=script&lang=js&"
export * from "./productimageSlider.vue?vue&type=script&lang=js&"
import style0 from "./productimageSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports